import {
  Grid,
  Typography,
  useTheme,
  Drawer,
  IconButton,
  Divider,
} from "@mui/material";
import React, { useState } from "react";

import "dayjs/locale/de";
import OrderForm from "./OrderForm";
import "./OrderDrawer.scss";
import CuoButton from "@/app/admin/_common/CuoButton";
import { X as CloseIcon, UserPlus as PersonAddAlt1Icon } from "lucide-react";

export default function ShowOrderForm({
  open,
  onClose,
  show,
  order,
}: {
  open: boolean;
  onClose: any;
  show?: any;
  order?: any;
}) {
  const [disableOnSubmit, setDisableOnSubmit] = useState(false);

  return (
    <Drawer anchor={"right"} open={open} className="guest-form-drawer">
      <Grid
        container
        alignContent={"start"}
        direction={"column"}
        className={"guest-form-container"}
      >
        <Grid container p={0.5} pl={1.5} alignItems={"center"}>
          <Grid container flex={1} alignItems={"center"}>
            <PersonAddAlt1Icon style={{ marginRight: "8px", width: "20px", height: "20px" }} />
            <Typography> Add guest </Typography>
          </Grid>

          <IconButton
            disableRipple
            disabled={disableOnSubmit}
            onClick={onClose}
          >
            <CloseIcon style={{ height: 20, width: 20 }} />
          </IconButton>
        </Grid>
        <Divider />
        <Grid container direction={"column"} flex={1}>
          <OrderForm
            disableOnSubmit={disableOnSubmit}
            setDisableOnSubmit={setDisableOnSubmit}
            show={show}
            order={order}
            closeForm={onClose}
          />
        </Grid>

        <Divider />

        <Grid
          container
          height={"65px"}
          justifyContent={"end"}
          columnGap={1}
          p={1.5}
        >
          <CuoButton
            variant="outline"
            label={"Cancel"}
            disabled={disableOnSubmit}
            onClick={onClose}
          />
          <CuoButton
            disableOnAsync={disableOnSubmit}
            variant="default"
            type="submit"
            form="new-guest-form"
            label={"Save"}
          />
        </Grid>
      </Grid>
    </Drawer>
  );
}
